import Field from '@/common/Field';
import { FieldTypes } from '@/common/Field/types';
import { ReactElement } from 'react';
import { getProperty } from '@/utils/objects';
import { useFormContext } from 'react-hook-form';

export type FormFieldProps = FieldTypes.Props & { name: string };

const FormField = ({ name, feedback, ...fieldProps }: FormFieldProps): ReactElement => {
  const form = useFormContext();
  const { errors = {} } = form.formState;
  const error = getProperty(name, errors, feedback);

  return <Field feedback={(error?.message as string) || feedback} {...fieldProps} />;
};

export default FormField;
